/* Destilo — sincronización de favoritos con la cuenta del cliente.

   El almacén de trabajo sigue siendo localStorage: los cuatro scripts que pintan
   corazones (pdp, products-showcase, pdp-related, favorites) leen y escriben ahí
   igual que antes, y quien navega sin cuenta no nota ningún cambio.

   Lo que añade esto es la otra mitad: si hay sesión iniciada, la lista también
   vive en el metacampo `custom.favoritos` del cliente, así que cruza de navegador
   y de dispositivo.

   Dos decisiones que conviene entender antes de tocar nada:

   · Se FUSIONA, no se sustituye. Entrar desde un móvil recién estrenado deja el
     localStorage vacío; si eso se subiera tal cual, borraría los favoritos
     guardados desde el portátil. Por eso el servidor une las dos listas.

   · Quitar un favorito sí tiene que restar, y una unión nunca resta. Por eso el
     módulo guarda una foto de la lista anterior y manda explícitamente lo que ha
     desaparecido, en `remove`.

   La configuración (si hay sesión y la lista de la cuenta) la inyecta Liquid en
   window.DestiloWishlistConfig — ver snippets/wishlist-config.liquid. */
(function () {
  var KEY = 'destilo_wishlist';
  var cfg = window.DestiloWishlistConfig || {};
  var ENDPOINT = cfg.endpoint || '/apps/favoritos';

  function leer() {
    try {
      var l = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(l) ? l : [];
    } catch (e) {
      return [];
    }
  }

  function escribir(lista) {
    try {
      localStorage.setItem(KEY, JSON.stringify(lista));
    } catch (e) {
      /* almacenamiento lleno o bloqueado (incógnito): se sigue sin persistir */
    }
  }

  function unir(a, b) {
    var out = [];
    var vistos = {};
    [a, b].forEach(function (lista) {
      (lista || []).forEach(function (h) {
        if (typeof h === 'string' && h && !vistos[h]) {
          vistos[h] = true;
          out.push(h);
        }
      });
    });
    return out;
  }

  // Foto de la última lista conocida, para saber qué se ha quitado.
  var anterior = leer();

  if (!cfg.loggedIn) {
    // Sin sesión no se llama al servidor en ningún caso. La API pública se deja
    // definida igual para que los scripts que la invocan no tengan que preguntar.
    window.DestiloWishlistSync = { push: function () {}, loggedIn: false };
    return;
  }

  var enVuelo = false;
  var pendiente = false;

  function enviar() {
    if (enVuelo) {
      pendiente = true;
      return;
    }
    var actual = leer();
    var quitados = anterior.filter(function (h) {
      return actual.indexOf(h) === -1;
    });
    var añadidos = actual.filter(function (h) {
      return anterior.indexOf(h) === -1;
    });
    if (!quitados.length && !añadidos.length) return; // nada que contar
    enVuelo = true;
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ favorites: actual, remove: quitados }),
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (data && data.ok && Array.isArray(data.favorites)) {
          // El servidor manda la lista buena (saneada y con el tope aplicado).
          escribir(data.favorites);
          anterior = data.favorites;
          avisar();
        }
      })
      .catch(function () {
        /* Sin red: el localStorage ya tiene el cambio y se reintenta al siguiente. */
      })
      .finally(function () {
        enVuelo = false;
        if (pendiente) {
          pendiente = false;
          enviar();
        }
      });
  }

  function avisar() {
    document.dispatchEvent(new CustomEvent('destilo:wishlist-synced'));
  }

  /* Arranque: la lista de la cuenta la trae Liquid ya renderizada, así que la
     fusión inicial no cuesta ninguna petición. Solo se llama al servidor si el
     navegador aporta algo que la cuenta no tenía. */
  var deLaCuenta = Array.isArray(cfg.favorites) ? cfg.favorites : [];
  var delNavegador = leer();
  var fusionada = unir(deLaCuenta, delNavegador);

  if (fusionada.join('|') !== delNavegador.join('|')) {
    escribir(fusionada);
    avisar();
  }

  // `anterior` pasa a ser lo que tenía la CUENTA. Así, si el navegador aportaba
  // algo que la cuenta no tenía, `enviar` lo ve como añadido y lo sube; y si las
  // dos listas ya coincidían, no encuentra nada y no llama al servidor.
  anterior = deLaCuenta;
  enviar();

  window.DestiloWishlistSync = { push: enviar, loggedIn: true };
})();
